import { selectChangeMessageForDevelopmentPhase } from '@UI/aside/asideDevelopmentPhase/asideDevelopmentPhaseSelectors';
import { selectChangeMessageForLeerlijnReference } from '@UI/aside/asideLeerlijnReference/AsideLeerlijnReferenceSelectors';
import { selectZillLeerlijnReferenceStepNode } from '@newStore/documentUI/transformContent/zillContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

const CURRICULUM_ZILL_LEERLIJN_POST_REFERENCE: BuildingBlockNodeConfig = {
  nodeSelector: selectZillLeerlijnReferenceStepNode,
  information: {
    single: 'Verwijs Stap (volgend)',
    plural: 'Verwijs Stapen (volgend)',
  },
  buildingBlocks: [],
  edit: [
    {
      component: 'developmentPhase',
      reactComponent: 'AsideDevelopmentPhase',
      label: 'Ontwikkelingsfase',
      showInAncestorTypes: [NodeType.CURRICULUM_ZILL_LEERLIJN_AN],
      asideChangeMessageSelector: selectChangeMessageForDevelopmentPhase,
    },
    {
      component: 'leerlijnReference',
      reactComponent: 'AsideLeerlijnReference',
      label: 'Verwijzing',
      asideChangeMessageSelector: selectChangeMessageForLeerlijnReference,
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: true,
  },
};

export default CURRICULUM_ZILL_LEERLIJN_POST_REFERENCE;
